import _ from 'lodash'
import qs from 'qs'
import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

import { removeEmpty } from 'utils'
export const mapFieldMonthlyReview = (item, index) => {
  return {
    key: item?.user_id,
    user_id: item?.user_id,
    employee: item?.employee,
    is_pool_org_code: item?.is_pool_org_code,
    is_pool_org_code_name: item?.is_pool_org_code_name,
    permission_org_structure: item?.permission_org_structure,
    total_report: item?.total_report,
    task_type: item?.task_type,
    count_header: item?.count_header,
    monthly_tracking_result: item?.monthly_tracking_result,
  }
}

export const getMonthlyReviewListApi = ({
  page,
  size,
  reporter_company_id,
  reporter_group_id,
  reporter_bu_id,
  reporter_division_id,
  reporter_department_id,
  reporter_section_id,
  risk_co_company_id,
  risk_co_group_id,
  risk_co_bu_id,
  risk_co_division_id,
  risk_co_department_id,
  risk_co_section_id,
  risk_owner_company_id,
  risk_owner_group_id,
  risk_owner_bu_id,
  risk_owner_division_id,
  risk_owner_department_id,
  risk_owner_section_id,
  report_status_id,
  start_date,
  end_date,
}) => {
  const params = removeEmpty({
    page,
    size,
    reporter_company_id,
    reporter_group_id,
    reporter_bu_id,
    reporter_division_id,
    reporter_department_id,
    reporter_section_id,
    risk_co_company_id,
    risk_co_group_id,
    risk_co_bu_id,
    risk_co_division_id,
    risk_co_department_id,
    risk_co_section_id,
    risk_owner_company_id,
    risk_owner_group_id,
    risk_owner_bu_id,
    risk_owner_division_id,
    risk_owner_department_id,
    risk_owner_section_id,
    report_status_id,
    start_date,
    end_date,
  })

  const config = {
    method: 'get',
    url: `/api/v1/monthly_review`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      const {
        data: { total, page, size },
        data,
      } = res
      if (data) {
        return responseSuccess({
          data: {
            items: _.map(data, mapFieldMonthlyReview),
            total: total,
            page: page,
            size: size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createMonthlyConfirmationTaskApi = (data) => {
  const config = {
    method: 'post',
    url: '/api/v1/tasks',
    data,
  }
  //console.log('SERVICE/PAYLOAD: ' + JSON.stringify(data, null, ' '))

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createMonthlyTrackingResultApi = (data) => {
  const config = {
    method: 'patch',
    url: '/api/v1/monthly_tracking_result',
    data,
  }
  //console.log('SERVICE/PAYLOAD: ' + JSON.stringify(data, null, ' '))

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
